"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var path_helper_1 = require("./config/path.helper");
var from_1 = require("rxjs/observable/from");
var calculation_config_model_1 = require("./model/calculation-config.model");
var calculation_measure_config_model_1 = require("./model/calculation-measure-config.model");
var column_config_model_1 = require("./model/config/column-config.model");
var column_model_1 = require("./model/config/column.model");
var operators_1 = require("rxjs/operators");
var HttpMeConfigService = /** @class */ (function () {
    function HttpMeConfigService(applicationPropertiesService, http) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(path_helper_1.PathHelper.meServiceUriKey));
    }
    HttpMeConfigService.prototype.getSystemCategoryItemsFilterConfig = function (systemName) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.CONFIG + ("/system-category-items-filter/" + systemName)); }));
    };
    HttpMeConfigService.prototype.getCalculationConfig = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.CONFIG + '/tracking-calculation-measures'); }), operators_1.map(function (res) { return _this.responseToCalculationConfig(res); }));
    };
    HttpMeConfigService.prototype.responseToCalculationConfig = function (res) {
        var calculationMeasureConfigs = [];
        if (res.builtInMeasures && res.builtInMeasures.length) {
            res.builtInMeasures.forEach(function (item) {
                var name = item.displayName;
                calculationMeasureConfigs.push(new calculation_measure_config_model_1.CalculationMeasureConfig(item.measure, name, item.isPercentage, item.numberOfDecimalPlaces, item.frequency, item.isRealTargetCalcData));
            });
        }
        return new calculation_config_model_1.CalculationConfig(res.allowCalculation, calculationMeasureConfigs);
    };
    HttpMeConfigService.prototype.getFilterMetas = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.CONFIG + '/indicator-filter'); }));
    };
    HttpMeConfigService.prototype.getIndicatorsPortfolioColumns = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.CONFIG + "/indicator-portfolio-table-columns"); }), operators_1.map(function (res) { return _this.responseToColumnConfigModel(res); }));
    };
    HttpMeConfigService.prototype.responseToColumnConfigModel = function (res) {
        var columns = [];
        if (res && res.columns && res.columns.length > 0) {
            res.columns.forEach(function (value) {
                columns.push(new column_model_1.ColumnModel(value.fieldSystemName));
            });
        }
        return new column_config_model_1.ColumnConfigModel(columns);
    };
    HttpMeConfigService.prototype.getIPPTConfig = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.CONFIG + '/ippt'); }));
    };
    HttpMeConfigService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService, idm_authentication_client_js_1.HttpClientWrapper])
    ], HttpMeConfigService);
    return HttpMeConfigService;
}());
exports.HttpMeConfigService = HttpMeConfigService;
//# sourceMappingURL=http-me-config.service.js.map